import React from "react";
import { Message } from "lib/components/vendor";

export default function FormMessage({ error }) {
  return (
    <Message error visible={!!error}>
      {error}
    </Message>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormMessage.jsx